<template>
    <div class="home-header flex align-center justify-between">
        <div class="flex align-center justify-start">
            <template v-if="!hasNoTitle">
                <img src="https://assets.pfotoo.com/wukong/logo.png" class="logo"/>
                悟空投票征集一下 I 征稿投票评选
            </template>
        </div>
        <div class="flex align-center justify-end tabs">
            <router-link to="/"><div :class="path=='/'?'active':''">首页</div></router-link>
            <router-link to="/produce"><div :class="path=='/produce'?'active':''">产品功能</div></router-link>
            <router-link to="/cooperate"><div :class="path=='/cooperate'?'active':''">商务合作</div></router-link>
        </div>
    </div>
</template>
<script>
  import App from '../../../util/comfun'
  export default {
    props:{
      hasNoTitle:Boolean,
    },
    data () {
      return {
        path:'',
      }
    },
    methods:{
      setActive(){
        console.log('setActive',this.$route.path)
        this.path=this.$route.path
      },
    },
    mounted(){
      this.setActive()
    },
  }
</script>

<style>
    .home-header{
        position: absolute;
        top:50px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        width: 88vw;
        z-index: 1;
    }
    .home-header .logo{
        width: 27px;
        height: 27px;
        margin-right: 11px;
    }
    .home-header .tabs{
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
    }
    .home-header .tabs div{
        height: 35px;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 35px;
        margin-left: 50px;
        box-sizing: border-box;
    }
    .home-header .tabs div.active{
        border-bottom: 2px solid #ffffff;
    }
    .home-header .tabs a{
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/pages/components/home/header.vue